import { type ComponentProps } from "react";

export function withImageFallback(fallbacks: string | string[]) {
  return ((event) => {
    const target = event.currentTarget;
    const queue = Array.isArray(fallbacks) ? fallbacks : [fallbacks];
    const currentIndex = Number(target.dataset.fallbackIndex || "0");
    const next = queue[currentIndex];

    if (!next) {
      target.onerror = null;
      return;
    }

    target.dataset.fallbackIndex = String(currentIndex + 1);
    target.src = next;
  }) as NonNullable<ComponentProps<"img">["onError"]>;
}
